import {
	BodyText,
	Flex,
	IconV2,
	LayoutBox,
	TextButton,
} from '@bamboohr/fabric';

export function FedMessage2020(props) {
	const { handleToggleClick } = props;

	return (
        <Flex
            alignItems="flex-start"
            marginBottom={ 1 }
            marginRight={ 1.5 }
            marginTop={ 1 }
        >
            <LayoutBox
                marginRight={ 0.5 }
            >
                <IconV2
                    color="neutral-strong"
                    name="circle-info-regular"
                    size={ 20 }
                />
            </LayoutBox>
            <BodyText
                size="small"
            >
                <span>{ $.__('The IRS W4 withholding form has changed') }. </span>
                <TextButton
                    inline={ true }
                    onClick={ handleToggleClick }
                    text={ $.__('Make changes using the new form fields.') }
                    type="button"
                />
            </BodyText>
        </Flex>
    );
}
